import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { UpdateDiscounts } from '../store';

@Injectable({
  providedIn: 'root',
})
export class DiscountViaUrlGuard  {
  constructor(private store: Store) {}
  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (route.params['discountCode']) {
      this.store.dispatch(UpdateDiscounts({ discountCodes: [route.params['discountCode']], redirect: ['/', 'cart'] }));
    }

    return true;
  }
}
